export default "__VITE_ASSET__YE9HH5Uz__"